export function composeSchema(args) {
    return {
        ...args,
        prototypes: {},
    };
}
export default composeSchema;
